// Copyright (c) 2018 Deere & Company

import actions from '../actions-list';
import {getDefaultState} from '../state';

const setFormToDirty = () => true;

const setFormToPrestine = () => false;

export default (state = getDefaultState().isFormDirty, action) => {

    const actionHandlers = {
        [actions.ADD_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE]: setFormToDirty,
        [actions.ADD_REQUEST_DETAILS_PICT_REQUEST_FORM_FILE]: setFormToDirty,
        [actions.RESET_FORM_IS_DIRTY_TO_FALSE]: setFormToPrestine,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_ANSWER]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_COMMENTS]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_FILE]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_INFO_REQUEST_FORM_RETURN_STATUS]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COMMENTS]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_COURIER_NAME]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_DISPATCH_DATE]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_RETURN_STATUS]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_PART_REQUEST_FORM_TRACKING_NUMBER]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_COMMENTS]: setFormToDirty,
        [actions.UPDATE_REQUEST_DETAILS_PICT_REQUEST_FORM_RETURN_STATUS]: setFormToDirty
    };

    const reducer = actionHandlers[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/request-details/reducers/is-form-dirty.js